/* eslint-disable */
import React from 'react';
import styles from './scopeFE.module.scss'; // Custom CSS module for styles
import Box from '@mui/material/Box';
import TotalScopeItems from '../../../../../Assets/images/svg/dar_scope_items.svg';
import TotalFEEfforts from '../../../../../Assets/images/svg/dar_fe_efforts.svg';
import ExternalIntegration from '../../../../../Assets/images/svg/dar_ext_integration.svg';
import TotalAPIs from '../../../../../Assets/images/svg/dar_total_apis.svg';
import ExpandableDataGrid from './gridView';
import ScopeBE from '../ScopeBE/scopeBE';
import PropTypes from 'prop-types';


const ScopeFE = ({effort}) => {
  const totalEfforts = [
    {
      id: 1,
      heading: 'Total Scope Items',
      value: '0',
      image: TotalScopeItems,
    },
    {
      id: 2,
      heading: 'Total FE Efforts',
      value: '0',
      image: TotalFEEfforts,
    },
    {
      id: 3,
      heading: 'External Integration',
      value: '0',
      image: ExternalIntegration,
    },
    {
      id: 4,
      heading: 'Total APIs',
      value: '0',
      image: TotalAPIs,
    },
  ];

  const renderEffortComponent = (effort) => {
    if (effort === 'FE') {
      return <ExpandableDataGrid />;
    } else if (effort === 'BE') {
      return <ScopeBE />;
    }
    return null;
  }

  return (
    <div>
      <div className={styles['scopeFe-totalEfforts-container']} style={{ display: 'none' }}>
        {totalEfforts.map((effort) => (
          <Box key={effort.id} className={styles['scopeFe-effort-box']}>
            <div className={styles['scopeFe-effort-heading']}>{effort.heading}</div>
            <div className={styles['scopeFe-inner-box']}>
              {effort.image && (
                <img
                  src={effort.image}
                  alt={effort.heading}
                  className={styles['scopeFe-effort-image']}
                />
              )}
              <div className={styles['scopeFe-effort-value']}>{effort.value}</div>
            </div>
          </Box>
        ))}
      </div>
      {renderEffortComponent(effort)}
    </div>
  );
};

export default ScopeFE;

ScopeFE.propTypes = { 
  effort: PropTypes.any, 
  };
